import { Component, Input } from '@angular/core';
import { Config } from '../../universal-config';

@Component({
  selector: 'nns-image',
  template: `
    <img [src]="fileServerUrl + attachment.attachmentURL"/>
  `,
})
export class ImageComponent {
  @Input() attachment;
  fileServerUrl: string;
  constructor(
    private config: Config
  ) {
    this.fileServerUrl = this.config.get('BOX_URL')
  }
}
